import { API } from '@brainstud/react-tbl/features/api'
import { loadProgress as loadNavigationProgress } from '@brainstud/react-tbl/features/navigation/store'
import { loadProgress as loadChaptersProgress } from '@brainstud/react-tbl/features/chapters/store'
// import { loadProgress as loadQuizesProgress } from '@brainstud/react-tbl/features/quiz/store'

/* ---------------------------------------------------- */

export const loginLoading = payload => {
  return { type: 'APP_LOGIN_LOADING', payload }
}
export const loginError = payload => {
  return { type: 'APP_LOGIN_ERROR', payload }
}
export const loginSuccess = payload => {
  return { type: 'APP_LOGIN_SUCCESS', payload }
}
export const endtestSuccess = payload => {
  return { type: 'APP_ENDTEST_PROGRESS', payload }
}

/* ---------------------------------------------------- */

export const doLogin = () => {
  return (dispatch, getState) => {
    dispatch(loginLoading())

    API.get('account').then(json => {
      if (!json) {
        dispatch(loginError('Error occurred'))
        return false
      }

      if (json.type && json.type === 'APP_LOGIN_ERROR') {
        dispatch(loginError('Error occurred'))
        return false
      }

      const endtest = json.endtest || {}
      const progress = json.progress || {}
      const navigation = progress.navigation || {}
      const chapters = progress.chapters || {}
      // const quizes = progress.quizes || {}

      dispatch(loadNavigationProgress(navigation))
      dispatch(loadChaptersProgress(chapters))
      // dispatch(loadQuizesProgress(quizes))
      dispatch(loginSuccess(json))
    })
  }
}
export const saveProgress = () => {
  return (dispatch, getState) => {
    const { account, navigation, chapters } = getState()

    API.put('account', {
      user: account.user,
      endtest: account.endtest,
      progress: {
        navigation: navigation.progress,
        chapters: chapters.progress,
        // quizes: quizes.progress,
      },
    }).then(res => console.log('saved', res))
  }
}

export const saveEndtest = (data) => {
  return (dispatch, getState) => {
    dispatch(endtestSuccess(data))
    dispatch(saveProgress())
  }
}

export const resetProgress = data => {
  return (dispatch, getState) => {
    API.put('account', data).then(res => console.log('reset', res))
  }
}

/* ---------------------------------------------------- */
